import t, { forwardRef as i } from "react";
import { c as s, t as p } from "./app-a75c1d35.mjs";
import { I as b, W as _ } from "./Icon-3122c134.mjs";
import { u as N } from "./useClickOutside-726e7c36.mjs";
const f = "button", C = "button__default-focus-style-in-link", S = "button__primary-focus-style-in-link", z = "button__map", k = "button__primary", L = "button__menu-talent", H = "button__arrows", I = "button__secondary", x = "button__quiz", T = "button__menu-employer", Q = "employer", M = "desktop", D = "button__hero", P = "button__hero-talents", B = "button__hero-employer", w = "button__save-container", R = "button__save", F = "button__menu", A = "button__icon", h = "button__icon__container", q = "button__link", g = "button__quiz__label", O = "mobile", V = "button__quiz__divider", U = "button__quiz__text", W = "button__quiz__correct", G = "button__quiz__incorrect", e = {
  button: f,
  buttonDefaultFocusStyleInLink: C,
  buttonPrimaryFocusStyleInLink: S,
  buttonMap: z,
  buttonPrimary: k,
  buttonMenuTalent: L,
  buttonArrows: H,
  buttonSecondary: I,
  buttonQuiz: x,
  buttonMenuEmployer: T,
  employer: Q,
  desktop: M,
  buttonHero: D,
  buttonHeroTalents: P,
  buttonHeroEmployer: B,
  buttonSaveContainer: w,
  buttonSave: R,
  buttonMenu: F,
  buttonIcon: A,
  buttonIconContainer: h,
  buttonLink: q,
  buttonQuizLabel: g,
  mobile: O,
  buttonQuizDivider: V,
  buttonQuizText: U,
  buttonQuizCorrect: W,
  buttonQuizIncorrect: G
}, lt = {
  Default: i(j),
  HeroTalents: i($),
  HeroEmployer: i(tt),
  Primary: i(J),
  Secondary: i(K),
  Save: i(X),
  Arrow: i(Z),
  Menu: i(et),
  IconLabel: i(nt),
  DefaultFocusStyleInLink: e.buttonDefaultFocusStyleInLink,
  PrimaryFocusStyleInLink: e.buttonPrimaryFocusStyleInLink,
  Quiz: i(ot),
  Link: i(ut)
};
function j({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      ...o,
      ref: n,
      className: s(e.button, o.className)
    },
    /* @__PURE__ */ t.createElement("span", { className: s(p.buttonTextPrimary) }, o.text),
    o.icon ? /* @__PURE__ */ t.createElement(b, { icon: o.icon, size: 14 }) : null
  );
}
function J(u, o) {
  const { icon: n, text: a, onClick: c, asDiv: r, preventEmployerStyle: l, ...m } = u, y = N(), E = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    E,
    {
      type: "button",
      ...m,
      className: s(
        e.button,
        e.buttonPrimary,
        y && !l && e.employer,
        u.className
      ),
      onClick: c,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ t.createElement("span", { className: s(p.buttonTextPrimary) }, a), n ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null)
  );
}
function K(u, o) {
  const {
    icon: n,
    text: a,
    onClick: c,
    asDiv: r,
    preventEmployerStyle: l,
    iconPosition: m,
    ...y
  } = u, E = N(), v = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    v,
    {
      className: s(
        e.button,
        e.buttonSecondary,
        E && !l && e.employer,
        u.className
      ),
      onClick: c,
      type: "button",
      ...y,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, n && m === "left" ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null, /* @__PURE__ */ t.createElement("span", { className: s(p.buttonTextPrimary) }, a), n && m !== "left" ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 12 }) : null)
  );
}
function X({ iconFilled: u, className: o, containerClassName: n, ...a }, c) {
  const r = s(
    e.buttonSaveContainer,
    n ?? ""
  );
  return /* @__PURE__ */ t.createElement("div", { className: r }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: s(e.button, e.buttonSave, o),
      ref: c,
      "aria-label": "save"
    },
    /* @__PURE__ */ t.createElement(
      b,
      {
        icon: u ? _.HEART_FILLED : _.HEART,
        size: 20
      }
    )
  ));
}
const Y = {
  left: "Previous",
  right: "Next",
  up: "Up",
  down: "Down"
};
function Z({
  arrowDirection: u,
  className: o,
  "aria-label": n,
  ...a
}, c) {
  const r = (l) => {
    switch (l) {
      case "up":
        return _.CHEVRON_UP;
      case "down":
        return _.CHEVRON_DOWN;
      case "left":
        return _.CHEVRON_LEFT;
      case "right":
      default:
        return _.CHEVRON_RIGHT;
    }
  };
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      ...a,
      className: s(e.button, e.buttonArrows, o),
      ref: c,
      "aria-label": n || Y[u]
    },
    /* @__PURE__ */ t.createElement(
      b,
      {
        size: 20,
        icon: r(u),
        "aria-hidden": !0,
        focusable: "false"
      }
    )
  );
}
function $({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      type: "button",
      ...o,
      className: s(e.button, e.buttonHeroTalents, o.className),
      ref: n
    },
    /* @__PURE__ */ t.createElement("span", { className: s(p.buttonHeroTitle) }, o.text)
  );
}
function tt({ asDiv: u, ...o }, n) {
  const a = u ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    a,
    {
      type: "button",
      ...o,
      className: s(
        e.button,
        e.buttonHeroEmployer,
        o.className
      ),
      ref: n
    },
    /* @__PURE__ */ t.createElement("span", { className: s(p.buttonHeroTitle) }, o.text)
  );
}
function et({ asDiv: u, isMenuOpen: o, ...n }, a) {
  const c = u ? "div" : "button", l = N() ? e.buttonMenuEmployer : e.buttonMenuTalent;
  return /* @__PURE__ */ t.createElement(
    c,
    {
      type: "button",
      ...n,
      className: s(
        e.button,
        e.buttonMenu,
        l,
        n.className
      ),
      ref: a,
      "aria-label": o ? "Close" : "Menu"
    },
    o ? /* @__PURE__ */ t.createElement(b, { icon: _.CLOSE }) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(b, { icon: _.SEARCH }), /* @__PURE__ */ t.createElement(b, { icon: _.HAMBURGER }))
  );
}
function nt(u, o) {
  const { icon: n, text: a, textClassName: c, onClick: r, buttonClassName: l, ...m } = u, y = s("button " + e.buttonIcon, l), E = s(p.textsLeadText, c);
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      className: y,
      onClick: r,
      type: "button",
      ...m,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonIconContainer }, /* @__PURE__ */ t.createElement("span", { className: E }, a), n && /* @__PURE__ */ t.createElement(
      b,
      {
        icon: n.type,
        size: n.size,
        className: n.className,
        color: n.color
      }
    ))
  );
}
function ot(u, o) {
  const {
    icon: n,
    text: a,
    onClick: c,
    asDiv: r,
    preventEmployerStyle: l,
    label: m,
    customClass: y,
    ...E
  } = u, v = N(), d = r ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    d,
    {
      className: s(
        e.button,
        e.buttonQuiz,
        v && !l && e.employer,
        y
      ),
      onClick: c,
      ...E,
      ref: o
    },
    /* @__PURE__ */ t.createElement("div", { className: e.buttonMap }, /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizLabel }, m), /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizDivider }), /* @__PURE__ */ t.createElement("span", { className: e.buttonQuizText }, a), n ? /* @__PURE__ */ t.createElement(b, { icon: n, size: 29 }) : null)
  );
}
function ut(u, o) {
  const { onClick: n, asDiv: a, preventEmployerStyle: c, label: r, customClass: l, ...m } = u, y = N(), E = a ? "div" : "button";
  return /* @__PURE__ */ t.createElement(
    E,
    {
      className: s(
        e.button,
        e.buttonLink,
        y && !c && e.employer,
        l
      ),
      onClick: n,
      type: "button",
      ...m,
      ref: o
    },
    r
  );
}
export {
  lt as B
};
//# sourceMappingURL=Button-c598cb52.mjs.map
